import validatePhone from '../../util/validatePhone';
import { validateEmail } from '../../util/email';

export const getCallBackErrors = ({ name, phone, email, message }) => {
  const errors = {};
  if (!name || typeof name !== 'string') {
    errors.name = 'Please leave your name';
  } else if (name.length < 2) {
    errors.name = 'Name is too short';
  }
  if (validatePhone(phone) === false) {
    errors.phone = 'Invalid phone number';
  }
  if (validateEmail(email) === false) {
    errors.email = 'Invalid email address';
  }
  if (!message || typeof message !== 'string' || message.length < 10) {
    errors.message = 'Please let us know when to call';
  }
  return errors;
};

export const getMessageErrors = ({ name, email, message }) => {
  const errors = {};
  if (!name || typeof name !== 'string') {
    errors.name = 'Please leave your namee';
  } else if (name.length < 2) {
    errors.name = 'Name is too short';
  }
  if (validateEmail(email) === false) {
    errors.email = 'Invalid email address';
  }
  if (!message || typeof message !== 'string' || message.length < 2) {
    errors.message = 'Please include a message';
  }
  return errors;
};
